import { IBrand } from '../../interfaces/Brand.interfaces';
import { IFilterOption } from '../../interfaces/Filter.interfaces';

const removeBrandTag = (brandName: string) => brandName.replace(/\(.+?\)$/, '').trim();

// 직거래 리스트는 제조사 태그(국제/동양/아세아텍) 없이 브랜드 단위로만 보여준다.
// 태그를 떼면 이름이 같아지는 브랜드(TYM(국제), TYM(동양))는 id를 ','로 묶어 한 옵션이 모두 조회하도록 한다.
export const createDirectDealBrandFilterOptions = (brands: IBrand[]): IFilterOption[] => {
  const options: IFilterOption[] = [];

  brands.forEach((brand) => {
    const optionName = removeBrandTag(brand.name);
    const sameNameOption = options.find((option) => option.optionName === optionName);

    if (sameNameOption) {
      sameNameOption.value = `${sameNameOption.value},${brand.id}`;
      return;
    }

    options.push({ optionName, value: brand.id, isDefault: false, isSelected: false });
  });

  return options;
};
